import { FiX } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";

import PageTitle from "@/components/ui/PageTitle";
import { FaChevronLeft } from "react-icons/fa";

/**
 * The overlay's top bar: what you are looking at on the left, the two things
 * you can do to it on the right.
 *
 * The row deliberately repeats the assets page's own header geometry —
 * `h-20`, `@[700px]:px-10 px-2`, and PageTitle — because the overlay sits
 * directly on top of that page, and a title that shifts as the panel opens
 * reads as the whole thing being misplaced. Change one and change the other:
 * see the header row in `AssetsEditor/index.jsx`.
 *
 * @input {assetName: 'Kick off', listName: 'Goal reel'}
 */
export default function AssetsListAssetPreviewHeader({
  assetName,
  listName,
  onRemoveFromList,
  onClose,
}) {
  return (
    <div className="AssetsListAssetPreview__header flex items-center bg-black justify-between gap-2 @[700px]:px-10 px-2 h-20 shrink-0">
      <div className="AssetsListAssetPreview__title min-w-0 flex-1 flex items-center gap-4 relative">
        <button
          type="button"
          title="Close preview"
          onClick={onClose}
          className="text-secondary-foreground hover:text-white cursor-pointer w-10 flex justify-center items-center rounded-md absolute -left-10">
          <FaChevronLeft className="w-4 h-4" />
        </button>
        <PageTitle id="AssetsListAssetPreview__heading" className="truncate">
          Assets List
        </PageTitle>
        <span
          id="AssetsListAssetPreview__name"
          className="AssetsListAssetPreview__name text-2xl font-thin truncate">
          {assetName}
        </span>
      </div>

      <div className="AssetsListAssetPreview__actions flex items-center gap-2 shrink-0">
        <button
          id="AssetsListAssetPreview__removeFromList"
          type="button"
          title={`Delete from ${listName}`}
          onClick={onRemoveFromList}
          className="AssetsListAssetPreview__removeFromList flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs text-secondary-foreground hover:bg-destructive hover:text-destructive-foreground cursor-pointer">
          <MdDeleteOutline className="w-4 h-4" />
          <span className="truncate max-w-[220px]">Remove from {listName}</span>
        </button>

        <button
          id="AssetsListAssetPreview__close"
          type="button"
          title="Close"
          onClick={onClose}
          className="AssetsListAssetPreview__close p-1.5 rounded-md text-secondary-foreground/70 hover:text-foreground hover:bg-secondary/60 cursor-pointer">
          <FiX className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
